// ContactUs.jsx - Ceylon Wayfinder Premium Taxi Service
import React, { useState } from 'react';
import './contactus.css';
import { db } from '../FirebaseComp/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import emailjs from "emailjs-com";
import { FiMapPin, FiPhone, FiMail, FiClock, FiSend, FiCheckCircle } from 'react-icons/fi';
import { FaShieldAlt, FaStar } from 'react-icons/fa';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);

    try {
      await addDoc(collection(db, 'ceylonwayfinder_contacts'), {
        ...formData,
        createdAt: serverTimestamp(),
        source: 'website'
      });

      await emailjs.send(
        "service_5x2anhk",
        "template_42c152h",
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message
        },
        "d8MPSVybGHqsEvNou"
      );

      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setErrors({});
      setTimeout(() => setSubmitted(false), 5000);

    } catch (error) {
      console.error("Error:", error);
      alert("Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contactus-container">
        <img 
          src="/bannerceylonwayfinder.png" 
          alt="Ceylon Wayfinder Premium Taxi Service" 
          className="aboutus-hero-image"
        />

      {/* Hero Banner */}
      <div className="contact-hero">

        <div className="contact-hero-overlay">


        </div>


        <div className="contact-hero-content">
          <h1>Contact <span>Ceylon Wayfinder</span></h1>
          <p>We're here to help 24/7. Reach out to us for any inquiries or bookings.</p>
          <div className="hero-badges">
            <span><FaStar /> 5/5 Rating</span>
            <span><FiClock /> 24/7 Support</span>
          </div>
        </div>
      </div>

      <div className="contact-content">

        {/* Contact Info Cards */}
        <div className="contact-info">
          <div className="info-card">
            <div className="info-icon"><FiMapPin /></div>
            <h4>Our Location</h4>
            <p>103/C, Temple road, Walpala<br />Andiambalama, Sri Lanka</p>
          </div>
          <div className="info-card">
            <div className="info-icon"><FiPhone /></div>
            <h4>Phone Numbers</h4>
            <p>+94 77 514 7957</p>
          </div>

          <div className="info-card">
            <div className="info-icon"><FiMail /></div>
            <h4>Email Us</h4>
            <p>info@ceylonwayfinder.com</p>
          </div>

          <div className="info-card">
            <div className="info-icon"><FiClock /></div>
            <h4>Working Hours</h4>
            <p>24/7 Support</p>
          </div>
        </div>

        {/* Contact Form */}
        <div className="contact-form-container">
          {submitted ? (
            <div className="success-message">
              <FiCheckCircle className="success-icon" />
              <h3>Message Sent Successfully!</h3>
              <p>Thank you for contacting Ceylon Wayfinder. We'll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name <span>*</span></label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name} 
                    onChange={handleChange} 
                    className={errors.name ? 'error' : ''} 
                    disabled={isSubmitting}
                    placeholder="Enter your full name"
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>

                <div className="form-group">
                  <label>Email Address <span>*</span></label>
                  <input 
                    type="email" 
                    name="email" 
                    value={formData.email} 
                    onChange={handleChange} 
                    className={errors.email ? 'error' : ''} 
                    disabled={isSubmitting}
                    placeholder="your@email.com"
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone Number</label>
                  <input 
                    type="tel" 
                    name="phone" 
                    value={formData.phone} 
                    onChange={handleChange} 
                    disabled={isSubmitting}
                    placeholder="+94 XX XXX XXXX"
                  />
                </div>

                <div className="form-group">
                  <label>Subject</label>
                  <select name="subject" value={formData.subject} onChange={handleChange} disabled={isSubmitting}>
                    <option value="">Select a subject</option>
                    <option value="booking">Booking Inquiry</option>
                    <option value="price">Price Information</option>
                    <option value="feedback">Feedback</option>
                    <option value="complaint">Complaint</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-group full-width">
                <label>Message <span>*</span></label>
                <textarea 
                  name="message" 
                  rows="5" 
                  value={formData.message} 
                  onChange={handleChange} 
                  className={errors.message ? 'error' : ''} 
                  disabled={isSubmitting}
                  placeholder="Tell us how we can help you..."
                ></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span className="loading-spinner"></span>
                    Sending...
                  </>
                ) : (
                  <>
                    <FiSend /> Send Message
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Map Section */}
      <div className="contact-map">
        <iframe
          title="Ceylon Wayfinder Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.8788341148525!2d79.92006297499856!3d7.14000749286415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zN8KwMDgnMjQuMCJOIDc5wrA1NScyMS41IkU!5e0!3m2!1ssi!2slk!4v1755059882988!5m2!1ssi!2slk"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactUs;